import TreeView from 'devextreme-react/tree-view';
import * as events from 'devextreme/events';
import React, { useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCommonContext } from '../../contexts/common';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import MainMenu from '../main-menu';
import './side-navigation-menu.scss';

export default function (props) {
  const { children, selectedItemChanged, openMenu, compactMode, onMenuReady } =
    props;

  const { isLarge } = useScreenSize();
  const { menuItems, translate } = useCommonContext();

  const {
    navigationData: { currentPath },
  } = useNavigation();


  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, 'dxclick');
      }

      wrapperRef.current = element;
      events.on(element, 'dxclick', (e) => {
        openMenu(e);
      });
    },
    [openMenu]
  );

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);
  //const items = useMemo(normalizePath, [user.sys_menus]);
  const renderTreeViewItem = (item) => {
    //return JSON.stringify(item);
    return (
      <Link to={item.path} className="menu-item">
        {item.icon != '' && <i className={item.icon}></i>}
        <span>{translate(item.name)}</span>
      </Link>
    );
  };

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {/* {children} */}
      <div style={{ height: window.innerHeight - 70 }}>
        <MainMenu />
      </div>
      {/* <div className={'menu-container menu-treeview'}>
        <TreeView
          ref={treeViewRef}
          items={menuItems.map(x => {
            return {
              ...x,
              isSelected: x.path == currentPath || `/${x.path}` == currentPath,
              items: !x.items ? [] : x.items.map(y => {
                return {
                  ...y,
                  isSelected: y.path == currentPath || `/${y.path}` == currentPath,
                }
              })
            }
          })}
          keyExpr={'id'}
          displayExpr={({ name }) => translate(name)}
          selectionMode="single"
          selectedExpr={"isSelected"}
          expandedExpr="expanded"
          // selectByClick={true}
          focusStateEnabled={true}
          selectNodesRecursive={true}
          selectedItemKeys={[165]}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
          itemRender={renderTreeViewItem}
        />
      </div> */}
    </div>
  );
}
